import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, useNavigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ClerkProvider } from '@clerk/react'
import { enUS, itIT } from '@clerk/localizations'
import { CLERK_ENABLED, CLERK_PUBLISHABLE_KEY } from './lib/clerk'
import i18n from './i18n/config'
import App from './App.jsx'
import './index.css'

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
    mutations: {
      retry: 1,
    },
  },
})

// Clerk flag-gated: il provider avvolge l'app solo se la publishable key è
// configurata (esplicita: l'auto-lettura dal pacchetto non vede le env Vite
// nei dep pre-bundlati); senza chiave l'app gira identica a prima.
//
// Vive DENTRO BrowserRouter per dargli routerPush/routerReplace: senza,
// dopo login/registrazione dalla modale Clerk navigherebbe con
// window.location (reload completo → flash della landing da sloggati e
// perdita dei File in memoria); col router la transizione è client-side.
//
// appearance: modale perfettamente centrata nel viewport (di default Clerk
// la appoggia in alto).
const ClerkWithRouter = ({ children }) => {
  const navigate = useNavigate()
  return (
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      // La finestra di accesso e registrazione nella lingua della dashboard
      // (prima era sempre in inglese).
      localization={String(i18n.language || '').startsWith('it') ? itIT : enUS}
      afterSignOutUrl="/"
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      appearance={{
        elements: {
          modalBackdrop: {
            alignItems: 'center',
            justifyContent: 'center',
          },
          modalContent: {
            margin: 0,
          },
        },
      }}
    >
      {children}
    </ClerkProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {CLERK_ENABLED ? (
          <ClerkWithRouter>
            <App />
          </ClerkWithRouter>
        ) : (
          <App />
        )}
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
